module.exports = __webpack_public_path__ + "asset/img/zh_tw_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/images/zh_tw_icon.svg
// module id = 741
// module chunks = 2 3 37